module.exports = __webpack_public_path__ + "static/media/KasaImg.b26a796c.PNG";